/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './textMarquee.less';
import { CommonUtil } from 'src/util/commonUtil';
let bem = createBEM('text-marquee');

export interface TextMarqueePropsI {
    speed?: string;
}

@Component
export default class TextMarquee extends Vue.Component<TextMarqueePropsI> {

    @Prop({
        type: Number,
        default: 1
    })
    speed!: number;

    needAnimate: boolean = true

    mounted() {
        let wrapper: any = this.$refs.wrapper;
        let domP: any = this.$refs.inner;
        let wrapperWidth = wrapper.offsetWidth;
        let innerWidth = domP.offsetWidth;
        if (wrapperWidth < innerWidth) {
            let offset = 0;
            let flag = true;
            let speed = 0.15*this.speed;
            let  animate =async ()=> {
                if (flag) {
                    offset -= speed;
                    if (offset <= wrapperWidth - innerWidth) {
                        offset =  wrapperWidth - innerWidth;
                        await CommonUtil.sleep(1000)
                        flag = !flag;
                    }
                }
                if (!flag) {
                    offset += speed;
                    if (offset >= 0) {
                        offset = 0;
                        await CommonUtil.sleep(1000)
                        flag = !flag;
                    }
                }
                domP.style = `transform: translateX(${offset}px);`
                if(!this.needAnimate) {
                    return
                }
                requestAnimationFrame(animate)
            }
            requestAnimationFrame(animate);
        }
    }

    beforeDestroy() {
        this.needAnimate = true
    }

    render(h) {
        return (
            <div class={bem()} ref="wrapper">
                <p ref="inner">{this.$slots.default}</p>
            </div>
        );
    }
}
